export const ADMIN_PROFILE_KEY = 'row-nation-admin-profile'

const USER_ID_CLAIM = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'
const ROLE_CLAIM = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'

const pick = (source, fields) => Object.fromEntries(
    fields.filter((field) => source?.[field] !== undefined).map((field) => [field, source[field]]),
)

export const saveAdminProfile = (user, club) => {
    if (!user?.id) return
    const profile = {
        user: pick(user, ['id', 'firstName', 'lastName', 'email', 'role', 'adminPermissions', 'permissions']),
        club: club || null,
    }
    try {
        localStorage.setItem(ADMIN_PROFILE_KEY, JSON.stringify(profile))
    } catch (error) {
        // The current in-memory session still works when storage is disabled.
    }
}

export const loadAdminProfile = () => {
    try {
        const profile = JSON.parse(localStorage.getItem(ADMIN_PROFILE_KEY))
        if (profile?.user?.id) return profile
    } catch (error) {
        // A malformed old value is treated as signed out.
    }
    clearAdminProfile()
    return null
}

export const clearAdminProfile = () => {
    try {
        localStorage.removeItem(ADMIN_PROFILE_KEY)
    } catch (error) {
        // Redux sign-out must proceed even when storage denies removal.
    }
}

export const tokenMatchesAdmin = (accessToken, user) => {
    if (!user?.id || !user?.role) return false
    try {
        const parts = accessToken.split('.')
        if (parts.length !== 3) return false
        const encoded = parts[1].replace(/-/g, '+').replace(/_/g, '/')
        const claims = JSON.parse(atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, '=')))
        const roles = Array.isArray(claims[ROLE_CLAIM]) ? claims[ROLE_CLAIM] : [claims[ROLE_CLAIM]]
        return String(claims[USER_ID_CLAIM]) === String(user.id) && roles.includes(user.role)
    } catch (error) {
        return false
    }
}
